function injectStyle (ssrContext) {
  this["$style"] = require("!!../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true,\"localIdentName\":\"[hash:base64]_0\",\"importLoaders\":true,\"modules\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-507b2571\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_globals.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_colors.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_fonts.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_variables.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_mixins.scss\",\"/Users/endriu/Work/adoratorio/temp/gtwr-site/src/styles/_functions.scss\"]}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PageContent.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageContent.vue"
import __vue_script__ from "!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PageContent.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-507b2571\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PageContent.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PageContent.vue
// module id = null
// module chunks = 